import { User } from "../gtm/User";
import { DatalayerUserConsent } from "../cmp/DatalayerUserConsent";

/**
 * This abstract class and its implementations is used to manage the different
 * ways that properties are accessed and set in the DataLayer in Radio-Canada's websites.
 * For example, DotCa has the rcId property but tou.tv use rcid (all in lowercase).
 */
export abstract class UserDataLayerAdapter {
  protected constructor(protected user: User) {}

  get cdpProfileId(): string | undefined {
    return this.user.cdpProfileId;
  }

  get rcId(): string | undefined {
    let rcId = this.user.rcId;
    if (!rcId) {
      rcId = this.user.rcid;
    }
    return rcId;
  }

  get identityProviderUserId(): string | undefined {
    return this.user.identityProviderUserId;
  }

  get planIds(): string | undefined {
    return this.user.planIds;
  }

  get ppid(): string | undefined {
    return this.user.ppid;
  }

  set ppid(value) {
    this.user.ppid = value;
  }

  get rc_plus_id(): string | undefined {
    return this.user.rc_plus_id;
  }

  set rc_plus_id(value) {
    this.user.rc_plus_id = value;
  }

  get rc_visitor_id(): string | undefined {
    return this.user.rc_visitor_id;
  }

  set rc_visitor_id(value) {
    this.user.rc_visitor_id = value;
  }

  get viafouraId(): string | undefined {
    return this.user.viafouraId;
  }

  get dataLayerUser(): User {
    return this.user;
  }

  get consent(): DatalayerUserConsent | undefined {
    return this.user.consent;
  }
}
